import type { IBetLimits } from '@pp/core/src/store/slices/bets/types';

import { Bets } from './bets';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const parseBetLimits = (result: Record<string, any>): IBetLimits => {
  return {
    [Bets.ONE]: {
      min: Number.parseFloat(result['per_bet_min_limit']) || 1,
      max: Number.parseFloat(result['per_bet_max_limit']) || 10,
    },
    [Bets.TWO]: {
      min: Number.parseFloat(result['per_bet_min_limit']) || 1,
      max: Number.parseFloat(result['per_bet_max_limit']) || 10,
    },
  };
};

export const tableConfigOptions = {
  parseBetLimits,
};

export const HIGHFLYER_PT = 'highflyerpt';